module.exports = __webpack_public_path__ + "static/index/img/baikal-108.82bedccd.jpg";